export const BLOCKS_ON_DELETE_REQUESTED = 'BLOCKS_ON_DELETE_REQUESTED';
export const BLOCKS_ON_DELETE_SUCCEEDED = 'BLOCKS_ON_DELETE_SUCCEEDED';
export const BLOCKS_ON_DELETE_FAILED = 'BLOCKS_ON_DELETE_FAILED';

export const BLOCKS_ON_GET_ALL_REQUESTED = 'BLOCKS_ON_GET_ALL_REQUESTED';
export const BLOCKS_ON_GET_ALL_SUCCEEDED = 'BLOCKS_ON_GET_ALL_SUCCEEDED';
export const BLOCKS_ON_GET_ALL_FAILED = 'BLOCKS_ON_GET_ALL_FAILED';

export const BLOCKS_ON_GET_FORM_REQUESTED = 'BLOCKS_ON_GET_FORM_REQUESTED';
export const BLOCKS_ON_GET_FORM_SUCCEEDED = 'BLOCKS_ON_GET_FORM_SUCCEEDED';
export const BLOCKS_ON_GET_FORM_FAILED = 'BLOCKS_ON_GET_FORM_FAILED';

export const BLOCKS_ON_GET_ONE_REQUESTED = 'BLOCKS_ON_GET_ONE_REQUESTED';
export const BLOCKS_ON_GET_ONE_SUCCEEDED = 'BLOCKS_ON_GET_ONE_SUCCEEDED';
export const BLOCKS_ON_GET_ONE_FAILED = 'BLOCKS_ON_GET_ONE_FAILED';

export const BLOCKS_ON_SAVE_REQUESTED = 'BLOCKS_ON_SAVE_REQUESTED';
export const BLOCKS_ON_SAVE_SUCCEEDED = 'BLOCKS_ON_SAVE_SUCCEEDED';
export const BLOCKS_ON_SAVE_FAILED = 'BLOCKS_ON_SAVE_FAILED';
